import instance from "./axios";

const getSingleConversation = async function (conversationId) {
  const { data } = await instance.get(`/conversation/single/${conversationId}`);

  return data;
};

export { getSingleConversation };
